import { render, staticRenderFns } from "./_recipe.vue?vue&type=template&id=55e2189e&scoped=true&lang=pug&"
import script from "./_recipe.vue?vue&type=script&lang=coffee&"
export * from "./_recipe.vue?vue&type=script&lang=coffee&"
import style0 from "./_recipe.vue?vue&type=style&index=0&id=55e2189e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e2189e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksSpacer: require('/opt/build/repo/nuxt-app/components/blocks/spacer.vue').default,Breadcrumbs: require('/opt/build/repo/library/components/globals/breadcrumbs.vue').default,ShareLinks: require('/opt/build/repo/library/components/globals/share-links.vue').default,CraftVisual: require('/opt/build/repo/node_modules/@bkwld/cloak/components/craft-visual.coffee').default,Btn: require('/opt/build/repo/nuxt-app/components/globals/btn/btn.vue').default,Wysiwyg: require('/opt/build/repo/node_modules/@bkwld/cloak/components/wysiwyg.coffee').default,BlocksProductCarousel: require('/opt/build/repo/nuxt-app/components/blocks/product-carousel.vue').default,BlocksStaggeredCardCarousel: require('/opt/build/repo/nuxt-app/components/blocks/staggered-card-carousel.vue').default,BlocksNewsletter: require('/opt/build/repo/nuxt-app/components/blocks/newsletter.vue').default})
